import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import {
  GRAFANA_ANNOTATION_ALERT_LABEL_SELECTOR,
  GRAFANA_ANNOTATION_DASHBOARD_SELECTOR,
  GRAFANA_ANNOTATION_OVERVIEW_DASHBOARD,
} from '@backstage-community/plugin-grafana';
import {
  GRAFANA_ANNOTATION_METRICS_SELECTOR,
  GRAFANA_ANNOTATION_SLO_LABEL_SELECTOR,
} from './grafanaClient';

const grafanaContent = EntityContentBlueprint.make({
  name: 'grafana',
  params: {
    path: '/grafana',
    title: 'Grafana',
    group: 'observability',
    filter: entity => {
      if (entity.kind.toLocaleLowerCase('en-US') !== 'component') {
        return false;
      }
      const annotations = entity.metadata.annotations ?? {};
      return Boolean(
        annotations[GRAFANA_ANNOTATION_DASHBOARD_SELECTOR] ||
          annotations[GRAFANA_ANNOTATION_ALERT_LABEL_SELECTOR] ||
          annotations[GRAFANA_ANNOTATION_OVERVIEW_DASHBOARD] ||
          annotations[GRAFANA_ANNOTATION_METRICS_SELECTOR] ||
          annotations[GRAFANA_ANNOTATION_SLO_LABEL_SELECTOR],
      );
    },
    loader: () =>
      import('./GrafanaContent').then(m => <m.GrafanaContent />),
  },
});

export const grafanaModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [grafanaContent],
});
